<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12 9.5V21M12 9.5L6 3M12 9.5L18 3M6 15H18M6 11H18" stroke="#2D9D99" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
